import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"

import { URL } from "app/config/api-config"

import {
    Grid,
    GridCell,
    Theme,
    css,
    Button,
    Progress,
    Spinner,
    Icon,
} from "@bdfx/mergado-ui-kit"

import { DiagnosticsType, ExtendedProductType, ProductTemplateType } from "../types";
import { projectId } from "app/helpers/api";
import { ExportsType, createSimilarityExport } from "app/reducers/exports"
import { ReduxList } from "app/types/app-types"
import { Template } from "app/types/model-types"
import { getLocale } from "app/helpers/session"


interface Props {
    product: ExtendedProductType
    products: ReduxList<DiagnosticsType>
    template: ProductTemplateType | Template
    exportSimilarity: ExportsType
    createSimilarityExport: typeof createSimilarityExport
}

class VisualSimilarityRender extends React.Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    render() {
        const { exportSimilarity, products, template } = this.props
        const { similar_images, similar_images_list_checksum, product_id, template_id, image_url, image_hash } = this.props.product

        if (!image_url) {
            return <div>{trans('no_image')}</div>
        }

        const template_ids = template.visual_similarity_templateids

        const percents = exportSimilarity.isExporting && exportSimilarity.data && exportSimilarity.data.exported_rows && exportSimilarity.data.total_rows ?
            Math.round((exportSimilarity.data.exported_rows / exportSimilarity.data.total_rows) * 100) : 0

        const className = products.isLoading ? 'muk-helper-loading-line with-line' : ''
        const isThisTemplate = `${exportSimilarity.data?.template_id}` === `${template_id}`

        const nLimit = 4    //template.visual_similarity_n
        const threshold = .5    //template.visual_similarity_threshold

        const d = similar_images?.results_at ? new Date(similar_images.results_at) : null
        const locale = getLocale().replace('_', '-')

        return <div className={className}>
            <SimilarImagesGrid>
                {similar_images && similar_images.results &&
                    similar_images.results.split("\n").map((row, k) => {
                        if (!row) {
                            return <GridCell key={`similar_${product_id}_${k}`}></GridCell>
                        }

                        const c = row.split(';')
                        const src = `${URL.laravelBase}get-source-image/${projectId}/${c[0]}`
                        return <GridCell key={`similar_${product_id}_${k}`}>
                            <div className="centering">
                                <a href={src} target="_blank"><img src={src} className={'max-image-size'} /></a>
                            </div>
                            <div className="centering">{c[1]}</div>
                        </GridCell>
                    })
                }
            </SimilarImagesGrid>

            {!template.visual_similarity_enabled && d &&
                <div style={{ padding: '10px' }}>
                    <Icon
                        type={'info-circled-radix'}
                        text={` ${trans('visual_similarity_last_update_at')} ${d.toLocaleDateString(locale)}  ${d.toLocaleTimeString(locale)}.`}
                        color={Theme.steelblue}
                    />
                </div>
            }

            {/* <StyledGrid>
                <GridCell />
                {(exportSimilarity.isExporting && isThisTemplate) ?
                    <GridCell>
                        {(percents > 0 && percents < 100) ?
                            <Progress
                                showLabel={true}
                                value={percents}
                                color="success"
                                max={100}
                                getValueLabel={(val) => val + ' % ' + trans('please_wait_generating_export')}
                            />
                            :
                            <Spinner type={'bubbles'} />
                        }
                    </GridCell> :
                    <React.Fragment>
                    <Button
                        type={'void'}
                        size={'big'}
                        secondary={true}
                        onClick={() => this.props.createSimilarityExport(template_id, template_ids, product_id, nLimit, threshold)}
                        color={Theme.steelblue}
                        disabled={exportSimilarity.isExporting}
                        actions={similar_images_list_checksum ? [
                            {
                                label: trans('create_list_and_publish_to_visual_similarity'),
                                onClick: () => this.props.createSimilarityExport(template_id, template_ids, product_id, nLimit, threshold)
                            }
                            ] : undefined}
                        >
                            {trans(similar_images_list_checksum ? 'find_similar_images' : 'create_list_and_publish_to_visual_similarity')}
                        </Button>
                    </React.Fragment>
                }
                <GridCell />
            </StyledGrid> */}
        </div>
    }
}

const StyledGrid = css(Grid)({
    gridTemplateColumns: 'auto max-content auto',
    ' span.muk-button.m-button-void.secondary': {
        padding: '6px 8px !important',
    }
})

const SimilarImagesGrid = css(Grid)({
    gridTemplateColumns: 'repeat(auto-fit, minmax(70px, 1fr))',
    ' .muk-gridcell': {
        textAlign: 'center',
        alignSelf: 'center',
    },
    ' img.max-image-size': {
        maxWidth: '80px',
        maxHeight: '80px',
    }
})

function mapStateToProps(state) {
    return {
        exportSimilarity: state.exportSimilarity,
        products: state.products,
    }
}

export default connect(mapStateToProps, {
    createSimilarityExport,
})(VisualSimilarityRender)